<template>
	<div :class="(large ? 'large ' : ' ') + 'bar-arrow-button ' + (moreRounded ? 'moreRounded ' : ' ')" :style="(flex ? 'height: 100%': ' ') + (bgImage ? ';background-image: url(' + bgImage + '); background-size: cover; background-repeat: no-repeat; background-position: top; ' : '')">
		<a :href="href">
			<v-row v-if="title">
				<v-col v-if="icon && icon != ''" class="icon-col v-col-3">
					<img :src="icon"/>
				</v-col>
				<v-col class="title-col">
					<div :class="'title ' + (bold ? 'bold' : '')" :style="(!icon ? 'padding-left:20px; ' : ' ') + (centerAlign ? 'text-align:center; ' : ' ')">{{ title }}</div>
				</v-col>
				<v-col class="arrow-col v-col-2">
					<img v-show="!hideArrow" class="arrow" src="../../assets/arrow-right.png">
					<img v-show="hideArrow" class="arrow">
				</v-col>
			</v-row>
			<div v-if="!title" class="mt-3"></div>
		</a>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "BarArrowButton",
	props: ['icon','title', 'href','bold', 'disabled', 'moreRounded', 'large', 'centerAlign', 'hideArrow', 'flex', 'bgImage'],
	data() {
		return{
			
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.bar-arrow-button {
	border-radius: 8px;
	padding: 6px;
	/* border: 1px solid var(--border-color); */
	background-color: var(--background-color);
}

.large {
	padding: 15px !important;
	padding-left: 6px !important;
	border-radius: var(--border-radius-m);
}

.moreRounded {
	border-radius: 30px;
}

.title-col {
	margin-top:auto;
	margin-bottom:auto;
}

.large .title-col {
	margin-top:auto;
	margin-bottom:auto;
}

.title {
	font-size: 12px;
}
.large .title {
	font-size: 16px;
}

.icon-col {
	margin-top:auto;
	margin-bottom:auto;
	text-align: left;
	padding-left: 15px;
}

.large .icon-col {
	padding-left: 25px;
}

.icon-col img {
	height: 30px;
}

.arrow-col {
	text-align: right;
	margin-top:auto;
	margin-bottom:auto;
	padding-right: 18px;
}

.arrow {
	height: 10px;
}

</style>